<template>
  <div>
    <v-btn
      small
      icon
      flat
      color="primary"
      :disabled="disabled"
      @click="pop"
      :class="styles"
    >
      <v-icon>undo</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { showLabelOnHover } from '@/components/Shared/Button/iconButtonStyles'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'UndoButton',
  data() {
    return {
      stack: [],
      position: 0,
    }
  },
  computed: {
    disabled() {
      return this.position === 0
    },
    styles() {
      return showLabelOnHover('やり直し')
    },
  },
  methods: {
    initialize(state) {
      const initialState = cloneDeep(state)
      this.stack = [initialState]
      this.position = 0
      this.initialState = initialState
    },
    push(state) {
      const newState = cloneDeep(state)
      this.stack = this.stack.slice(0, this.position + 1)
      this.stack.push(cloneDeep(newState))
      this.position++
      this.$emit('push', newState)
    },
    pop() {
      const state = cloneDeep(this.stack[--this.position])
      this.$emit('pop', state)
    },
  },
}
</script>

<style scoped></style>
